import {mapGetters} from 'vuex';

export default {
    name: 'homeNavigation',
    computed: {
        ...mapGetters('glb', ['glb']),
        navigationItems() {
            const items = [
                {
                    title: this.molang('home.bottomCards.guide.title'),
                    description: this.molang('home.bottomCards.guide.description'),
                    href: this.glb.appUrl + 'guide/',
                    icon: 'icon-road-sign',
                    link: this.molang('home.bottomCards.guide.link'),
                },
                {
                    title: this.molang('home.bottomCards.marketTrends.title'),
                    description: this.molang('home.bottomCards.marketTrends.description'),
                    href: this.glb.appUrl + 'market-trends/',
                    icon: 'icon-graph-increasing',
                    link: this.molang('home.bottomCards.marketTrends.link'),
                },
                {
                    title: this.molang('home.bottomCards.schools.title'),
                    description: this.molang('home.bottomCards.schools.description'),
                    href: this.glb.appUrl + 'schools/',
                    icon: 'icon-cap',
                    link: this.molang('home.bottomCards.schools.link'),
                },
                {
                    title: this.molang('home.bottomCards.tips.title'),
                    description: this.molang('home.bottomCards.tips.description'),
                    href: this.glb.appUrl + 'blog/category/tips-how-tos/',
                    icon: 'icon-open-house',
                    link: this.molang('home.bottomCards.tips.link'),
                },
            ]
            return items;
        }
    }
};